import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ListFilterRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CHATS } = ServerConstants;
const { REQUEST_CHATS_LIST_ID, REQUEST_CHATS_ONE_ID, REQUEST_CHATS_MESSAGES_LIST_ID, REQUEST_CHATS_MESSAGES_READ_ID, REQUEST_CHATS_MESSAGES_CREATE_ID, REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID } = ServiceConstants;


export async function chatsAll(filter: ListFilterRequest) {
  const requestId = REQUEST_CHATS_LIST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CHATS}?page=${filter.page}&search=${filter.search}&pageSize=30`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatsAll, [filter], requestId);
  }
}

export async function chatsOne(userId: number) {
  const requestId = REQUEST_CHATS_ONE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CHATS}/single?userId=${userId}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatsOne, [userId], requestId);
  }
}

export async function chatMessages(id: number | string, filter: ListFilterRequest) {
  const requestId = REQUEST_CHATS_MESSAGES_LIST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CHATS}/${id}/messages?page=${filter.page}&pageSize=50`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatMessages, [id, filter], requestId);
  }
}

export async function chatMessagesRead(id: number | string) {
  const requestId = REQUEST_CHATS_MESSAGES_READ_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CHATS}/${id}/messages/read`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatMessagesRead, [id], requestId);
  }
}

export async function chatMessageCreate(userToId: number, message: string) {
  const requestId = REQUEST_CHATS_MESSAGES_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const body = {
      userToId: userToId,
      message: message
    }
    const response = await APIKit.post(`${API_V1_CHATS}`, body);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
    return true;
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatMessageCreate, [userToId, message], requestId);
    return false;
  }
}

export async function chatMessageAttachmentUpload(id: number, userToId: number, files: any[]) {
  const requestId = REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID;
  try {
    store.dispatch(start(requestId));
    const formData = new FormData();
    formData.append("id", id.toString());
    formData.append("userTo", userToId.toString());
    files.forEach((file: any) => {
      formData.append("files", file);
    });
    const response = await APIKit.post(`${API_V1_CHATS}/attachments/multiple`, formData, {
      headers: {
        ...APIKit.defaults.headers['common'],
        'Accept-Language': APIKit.defaults.headers['Accept-Language'],
        'Content-Type': 'multipart/form-data'
      }
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, chatMessageAttachmentUpload, [id, files], requestId);
  }
}